<template>
  <div
    class="iframe"
    ref="iframe"></div>
</template>

<script>
import config from '@/config'
import DailyIframe from '@daily-co/daily-js'
export default {
  name: 'VideoEmbed',
  components: {
  },
  props: {
    roomId: {
      type: String,
      required: true
    },
    userName: {
      type: String,
      default: 'Guest'
    },
    showLeaveButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      callFrame: null
    }
  },
  computed: {
  },
  mounted () {
    const prev = DailyIframe.getCallInstance && DailyIframe.getCallInstance()
    if (prev && !prev.isDestroyed()) {
      prev.destroy()
    }
    this.callFrame = DailyIframe.createFrame(this.$refs.iframe, {
      iframeStyle: {
        width: '100%',
        height: '100%',
        border: '0'
      },
      showLeaveButton: this.showLeaveButton,
      userName: this.userName
    })
    this.callFrame.join({ url: `https://${config.daily.domain}/${this.roomId}` })
  },
  beforeDestroy () {
    if (this.callFrame) {
      this.callFrame.leave()
      this.callFrame.destroy()
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Meet/VideoEmbed.vue